import { render, staticRenderFns } from "./LoadingDataPageContainer.vue?vue&type=template&id=2cb22b7a&"
import script from "./LoadingDataPageContainer.vue?vue&type=script&lang=js&"
export * from "./LoadingDataPageContainer.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDataPageContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
